import { IHotel } from '@entities/hotel/@/tourProduct';
import TourProduct from '../model/TourProduct';

export default function (groupedTourProducts: TourProduct[][]): IHotel[] {
    return groupedTourProducts.reduce((acc, tourProducts) => {
        if(tourProducts[0]?.hotel) {
            acc.push(tourProducts[0]?.hotel)
        }
        return acc;
    }, [] as IHotel[]);
}